import { environment } from '~app/environment';

export const getAwsWafDomains = () => {
  const apiDomain = environment.API_HOST.startsWith('/')
    ? 'api-test.breezeventures.io'
    : new URL(environment.API_HOST).hostname;
  const domains: string[] = [apiDomain];

  if (typeof window !== 'undefined') {
    domains.push(window.location.hostname);
  }

  return domains;
};
